import HeaderComponent from "./Header/HeaderComponent";
import MenuComponent from "./Menu/MenuComponent";
import MobileHeaderComponent from "./Header/MobileHeaderComponent";
import { useMedia } from "react-media";
import { useTranslation } from "react-i18next";
import { GLOBAL_MEDIA_QUERIES } from "../../constatnts";
import { useQuery } from "react-query";
import { getMenu } from "../../api/api";
import { useEffect } from "react";



  const LayoutTop = () => {
  const matches = useMedia({ queries: GLOBAL_MEDIA_QUERIES });
  const { t, i18n } = useTranslation();

const { isLoading, error, data, isFetching, refetch }: any = useQuery(
  "MenuData",
  () =>
    getMenu({
      language: i18n.language,
    })
);

useEffect(() => {
  refetch();
}, [i18n.language]);


if (isLoading) return <div></div>;

  return (
    <>
    <HeaderComponent/>
    <MobileHeaderComponent items={data.data.items}/>
    <MenuComponent items={data.data.items}/>

    </>
  );
}

export default LayoutTop;
